import React, { useState, useEffect, useMemo, Fragment } from 'react';
import { useStore } from '@nanostores/react';
import { isCartOpen, cartData } from '@stores/cartStore.js';

import 'balloon-css';

import { createCart, addToCart } from '@api/shopify.js';

import SizeGuide from '@components/SizeGuide/SizeGuide.jsx';

import {
	slugify,
	splitLastOccurrence,
	unslugify,
	sizeSortFunc,
	getUniqueListBy,
} from '@utils/utils';

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/';

const ProductTile = ({ productData, slug, productColor, numberOfProducts }) => {
	//
	//
	const [cart, setCart] = useState();
	const $cartData = useStore(cartData);
	const [open, setOpen] = useState(false);

	let products = productData.products;

	products = products.filter(function (el) {
		return el.handle.split('_')[0] === slug;
	});

	let productTitleProduct = products.filter((p) => {
		return p.handle === slug;
	});

	let productTitle = productTitleProduct[0]?.title.replace(' [hidden]', '');

	//

	let variants = products.map((p) => {
		return p.variants;
	});

	variants = variants.flat();

	variants = variants.filter(function (el) {
		return el.inventory_quantity > 0;
	});

	let initialColorVariant = variants?.filter((v) => {
		if (v.initial_color && productColor) {
			return slugify(v.initial_color) === productColor;
		}
	});

	//

	initialColorVariant = initialColorVariant[0];

	let initialVariant = variants ? variants[0] : null;

	//

	let swatches = useMemo(() => [], []);

	variants?.forEach((v) => {
		swatches.push(v.initial_color);
	});

	swatches = [...new Set(swatches)];

	//

	const [currentProduct, setCurrentProduct] = useState(products[0]);

	const [currentColor, setCurrentColor] = useState(
		initialColorVariant?.initial_color ||
			variants[0]?.initial_color ||
			products[0]?.options_with_values[0]?.values[0]?.title
	);

	const [sizes, setSizes] = useState([]);
	const [currentSize, setCurrentSize] = useState({
		size: '',
		variantId: '',
		sku: '',
	});

	const [quantity, setQuantity] = useState(1);

	const [currentImage, setCurrentImage] = useState({
		src: initialColorVariant?.image || products[0]?.images_info[0]?.src,
		alt: productTitle ? productTitle : products[0]?.title,
	});

	const [currentPrice, setCurrentPrice] = useState({
		price: initialVariant?.price,
		compareAtPrice: initialVariant?.compareAtPrice,
	});

	/* product images */
	let allProductImages = products.map((p) => {
		let images = p.images_info.map((v, i) => {
			//

			const currentColorSlug = slugify(currentColor);

			const [srcBefore, srcAfter] = splitLastOccurrence(v.src, '.');

			const imageSrc = srcBefore + '_1200x1200.' + srcAfter;
			return {
				imageSrc: imageSrc,
				imageAlt: v.alt ? v.alt : slugify(currentColor),
				position: v.position,
				colorSlug: v.alt ? v.alt : '',
				initial_color: v.alt ? unslugify(v.alt) : '',
				id: v.id,
			};
		});
		return images;
	});

	allProductImages = allProductImages.flat(1);

	//

	/* product sizes */
	useEffect(() => {
		let initialSizes = [];

		let allVariants = variants;

		//

		allVariants.map((v) => {
			if (v.initial_size && v.initial_color === currentColor) {
				initialSizes.push({
					variantId: v.id,
					inventory_quantity: v.inventory_quantity,
					sku: v.sku,
					productId: v.product_id,
					price: v.price,
					initial_size: v.initial_size,
				});
			}
			return null;
		});

		initialSizes = initialSizes.filter(function (e) {
			return (
				e.initial_size !== null &&
				e.initial_size !== undefined &&
				e !== ''
			);
		});

		//

		if (initialSizes.length > 0) {
			let sortedSizeList = initialSizes.sort(sizeSortFunc);
			//

			sortedSizeList = getUniqueListBy(sortedSizeList, 'initial_size');

			sortedSizeList = sortedSizeList.filter(function (e) {
				return e !== null && e !== undefined && e !== '';
			});

			if (sortedSizeList.length > 0) {
				//
				setSizes(sortedSizeList);
			}
		} else {
			//
			setCurrentSize({
				size: 'nosize',
				variantId: initialVariant && initialVariant.id,
				sku: initialVariant && initialVariant.sku,
			});
			setSizes([]);
		}
		// eslint-disable-next-line
	}, []);

	const handleSwatchClick = (swatchSlug, swatchTitle, index) => {
		//

		setCurrentColor(swatchTitle);

		let currentColorImages = allProductImages.filter((i) => {
			return i.colorSlug === swatchSlug;
		});

		//

		setCurrentImage({
			src: currentColorImages[0]?.imageSrc,
			alt: productTitle ? productTitle : products[0]?.title,
		});

		let allVariants = variants;

		let matchingVariants = allVariants.filter((v) => {
			return v.initial_color === swatchTitle;
		});

		let matchingVariantSizes = [];

		matchingVariants.map((v) => {
			if (v.initial_size && v.initial_size !== '') {
				matchingVariantSizes.push({
					variantId: v.id,
					inventory_quantity: v.inventory_quantity,
					sku: v.sku,
					productId: v.product_id,
					price: v.price,
					initial_size: v.initial_size,
				});
			}

			return null;
		});

		matchingVariantSizes = getUniqueListBy(
			matchingVariantSizes,
			'initial_size'
		);

		matchingVariantSizes.map((s) => {
			if (s.initial_size === currentSize) {
				setCurrentSize(currentSize);
			} else {
				setCurrentSize('');
			}
			return null;
		});

		//

		setSizes(matchingVariantSizes);

		if (
			currentSize.size &&
			currentSize.size !== '' &&
			currentSize.size !== null &&
			currentSize.size !== 'nosize'
		) {
			let matchingVariant = matchingVariants.filter((v) => {
				return v.initial_size === currentSize.size;
			});

			if (matchingVariant && matchingVariant[0]) {
				setCurrentPrice({
					price: matchingVariant[0].price,
					compareAtPrice: matchingVariant[0].compareAtPrice,
				});
			}
		} else {
			let matchingId = matchingVariants[0].id;
			let matchingVariantProductId = matchingVariants[0].product_id;

			let matchingProduct = products.filter((p) => {
				return p.id === matchingVariantProductId;
			});

			setCurrentPrice({
				price: matchingVariants[0].price,
				compareAtPrice:
					matchingVariants[0].compareAtPrice ||
					matchingVariants[0].compare_at_price,
			});

			if (currentSize.size === 'nosize' || !currentSize.size) {
				setCurrentSize({
					size: 'nosize',
					variantId: matchingId,
				});
			} else {
				setCurrentSize({
					size: '',
					variantId: matchingId,
				});
			}
		}
	};

	const handleSizeClick = (size, variantId, index, sku) => {
		let ele = document.getElementsByClassName('size size-selected');
		if (ele.length > 0) {
			ele[0].classList.remove('size-selected');
		}
		setCurrentSize({
			size: size,
			variantId: variantId,
			sku: sku,
		});
		setQuantity(1);
	};

	const handleQuantityDecrement = () => {
		setQuantity((prevQuantity) => {
			if (prevQuantity === 1) {
				return 1;
			}
			if (prevQuantity === 0) {
				return 1;
			}
			return prevQuantity - 1;
		});
	};

	const handleQuantityChange = (e) => {
		let value = e.target.value;
		if (value > 0 && value < 100) {
			setQuantity(value);
		}
	};

	const handleQuantityIncrement = () => {
		const min = 0;
		const max = 99;
		let value = parseInt(quantity);

		value += 1;

		if (value > max) value = max;
		if (value < min) value = min;

		setQuantity(value);
	};

	const handleAddToCart = async (e) => {
		const noClick = e.target.classList.contains('noclick');

		if (noClick) {
			return;
		}

		e.preventDefault();

		let cartId = $cartData.cartId || '';

		let variantId = currentSize.variantId;
		const product = `gid://shopify/ProductVariant/${variantId}`;

		//

		let lines = {
			quantity: Number(quantity),
			merchandiseId: product,
		};

		if (!cartId || cartId === '') {
			let cartCreateData = await createCart();
			cartId = cartCreateData.data.cartId;

			//

			let cartObj = {
				...cartData.get(),
				cartId: cartId,
				checkoutUrl: cartCreateData.data.checkoutUrl,
			};

			cartData.set(cartObj);

			//

			addToCart(cartId, lines).then((addToCartData) => {
				//
				let cartLines =
					addToCartData.body?.cartLinesAdd?.cart?.lines?.edges;
				let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost;
				//

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);
				clearOptions();

				if (sizes.length > 0) {
					setCurrentSize({
						size: '',
						variantId: '',
						sku: '',
					});
				} else {
					setCurrentSize({
						size: 'nosize',
						variantId:
							initialVariant &&
							initialVariant[0] &&
							initialVariant[0].id,
						sku:
							initialVariant &&
							initialVariant[0] &&
							initialVariant[0].sku,
					});
				}
			});
		} else {
			//

			addToCart(cartId, lines).then((addToCartData) => {
				//

				let cartLines =
					addToCartData.body?.cartLinesAdd?.cart?.lines?.edges;
				let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);
				isCartOpen.set('is_cart_open', true);

				if (sizes.length > 0) {
					setCurrentSize({
						size: '',
						variantId: '',
						sku: '',
					});
				} else {
					setCurrentSize({
						size: 'nosize',
						variantId:
							initialVariant &&
							initialVariant[0] &&
							initialVariant[0].id,
						sku:
							initialVariant &&
							initialVariant[0] &&
							initialVariant[0].sku,
					});
				}
			});
		}
	};

	return (
		<div className='product-tile-outer'>
			<div
				className={`product-tile-inner ${
					numberOfProducts === 1
						? 'flex gap-8 flex-wrap lg:flex-nowrap'
						: ''
				}`}
			>
				<div
					className={`product-tile-image mb-2 cursor-pointer ${
						numberOfProducts === 1 ? 'w-full lg:w-1/2' : ''
					}`}
				>
					<a
						className='cursor-pointer'
						href={
							initialVariant?.id
								? `/products/${slug}?variant=${initialVariant?.id}`
								: `/products/${slug}`
						}
					>
						<img src={currentImage.src} alt={currentImage.alt} />
					</a>
				</div>
				<div
					className={`product-wrap ${
						numberOfProducts === 1 ? 'w-full lg:w-1/2' : ''
					}`}
				>
					<div className='product-tile-title cursor-pointer'>
						<h3>
							<a
								className='cursor-pointer'
								href={
									initialVariant?.id
										? `/products/${slug}?variant=${initialVariant?.id}`
										: `/products/${slug}`
								}
							>
								{productTitle
									? productTitle.split('_')[0]
									: products[0]?.title.split('_')[0]}
							</a>
						</h3>
					</div>

					<div className='product-tile-price'>
						<p className='product-price !mb-2'>
							{currentPrice.compareAtPrice ? (
								<span className='product-price-compare'>
									${currentPrice.compareAtPrice}
								</span>
							) : null}
							<span className='product-price-current'>
								${currentPrice.price}
							</span>
						</p>
					</div>

					<div className='product-actions product-actions-outer pb-3 border-b border-slate'>
						<div className='product-actions-inner flex flex-wrap lg:flex-nowrap items-center gap-x-4 items-center'>
							<div className='product-add-to-cart w-full max-w-[400px] relative lg:top-[4px]'>
								<Fragment>
									{!currentSize.size ? (
										<p className='block mobile-size-error text-xs mb-0 text-gray-500 w-full md:hidden'>
											Please select a size
										</p>
									) : null}
									<input
										type='hidden'
										min='1'
										name='quantity'
										value={quantity}
									/>
									<input
										type='hidden'
										name='id'
										id='variant-id'
										value={
											currentSize.variantId
												? currentSize.variantId
												: variants.length > 0
												? variants[0].id
												: ''
										}
									/>
								</Fragment>
								<button
									type={!currentSize.size ? null : 'submit'}
									id='pdp-add-to-cart'
									className={`large-button button-atc w-full !h-12 flex-grow mb-2 ${
										!currentSize.size
											? 'disabled noclick !opacity-50 cursor-not-allowed'
											: 'hover:bg-ash opacity-100'
									}`}
									// data-balloon-blunt
									data-balloon-pos='up'
									aria-label={
										!currentSize.size
											? 'Please select a size'
											: null
									}
									onClick={(e) => handleAddToCart(e)}
								>
									Add To Cart
								</button>
							</div>

							<div className={`product-quantity flex flex-col`}>
								{/* <div className="product-quantity-label text-xs mb-2">
                                Quantity:
                            </div> */}
								<div className='product-quantity-wrap flex items-center gap-0 h-[42px] lg:mr-3 '>
									<button
										className={`quantity-decrement bg-slate text-lg aspect-square w-8 h-12 ${
											quantity === 1
												? 'quantity-disabled'
												: ''
										}`}
										onClick={handleQuantityDecrement}
									>
										<span className='minus'>–</span>
									</button>
									<input
										className='quantity-input text-center w-12 text-lg flex-1 border border-slate h-12'
										type='number'
										name='quantity'
										value={quantity}
										onKeyPress={(e) => {
											if (e.target.value.length > 2)
												e.preventDefault();
										}}
										onChange={handleQuantityChange}
										max='99'
									/>
									<button
										className='quantity-increment aspect-square bg-slate text-lg w-8 h-12'
										onClick={handleQuantityIncrement}
									>
										<span className='plus'>+</span>
									</button>
								</div>
							</div>
						</div>
					</div>
					{swatches.length > 1 ? (
						<div className='product-tile-swatches my-2'>
							<ul className='swatch-list nostyle flex flex-wrap gap-1 items-center'>
								{swatches.slice(0, 8).map((s, i) => {
									let swatchSlug;
									if (s) swatchSlug = slugify(s);
									return (
										<li
											key={swatchSlug}
											className={`swatch swatch-item w-8 hover:cursor-pointer ${
												currentColor &&
												currentColor ===
													s.replace(/\//g, ' ')
													? 'swatch-selected'
													: ''
											}`}
											data-swatch-index={i}
											data-swatch-color={swatchSlug}
											aria-label={s}
											data-balloon-pos='up'
											onClick={() =>
												handleSwatchClick(
													swatchSlug,
													s,
													i
												)
											}
										>
											<div className='swatch-image'>
												<img
													className='rounded-full border border-oat hover:border-ocean hover:border-2'
													src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
													alt={s}
												/>
											</div>
										</li>
									);
								})}
								{swatches.length > 8 ? (
									<span className='text-xs ml-2'>
										<a
											className='cursor-pointer underline'
											href={
												initialVariant.id
													? `/products/${slug}?variant=${initialVariant.id}`
													: `/products/${slug}`
											}
										>
											+ {`${swatches.length - 8}`} more
										</a>
									</span>
								) : null}
							</ul>
						</div>
					) : null}

					{sizes && sizes.length ? (
						<div className='product-sizes pt-3 border-t border-slate'>
							<ul className='size-list nostyle grid grid-cols-5 gap-2'>
								{sizes.map((s, i) => {
									{
										/**/
									}
									if (
										s.initial_size &&
										s.initial_size !== ''
									) {
										return (
											<li
												key={s.initial_size}
												className={`size h-[28px] border border-oat rounded-sm flex items-center justify-center px-2 text-xs hover:cursor-pointer hover:bg-flint hover:text-white  ${
													currentSize.size &&
													currentSize.size ===
														s.initial_size
														? 'size-selected bg-ash text-white'
														: 'bg-white'
												} ${
													s.inventory_quantity === 0
														? 'size-out-of-stock cursor-not-allowed pointer-events-none'
														: ''
												}`}
												onClick={() =>
													handleSizeClick(
														s.initial_size,
														s.variantId,
														i,
														s.sku
													)
												}
												data-variant-id={s.variantId}
											>
												<span className='size-label text-xs'>
													{s.initial_size}
												</span>
											</li>
										);
									}
									return null;
								})}
							</ul>
							{/* <div className="size-guide-wrap ml-auto mt-2">
                            <SizeGuide />
                        </div> */}
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};
export default ProductTile;
